import AgentAssistedMemberIdRequest from 'interfaces/AgentAssistedMemberIdRequest';
import AgentAssistedPcpChangeRequest from 'interfaces/AgentAssistedPcpChangeRequest';
import { getAuthHeaders, getSearchParamsString } from './api';
import { handleResponseConversionToJSON } from './utility';

const PAGE_SIZE = 15;

const changePcp = async (
    authToken: string,
    request: AgentAssistedPcpChangeRequest
) => {
    const headers = getAuthHeaders(authToken);

    return await fetch('api/MemberServices/ChangePcp', {
        method: 'POST',
        headers,
        body: JSON.stringify(request),
    }).then(handleResponseConversionToJSON);
};

const getPcpChangeRequests = async (
    authToken: string,
    memberId: string,
    page: number,
    pageSize: number = PAGE_SIZE,
    abortSignal?: AbortSignal
) => {
    const headers = getAuthHeaders(authToken);

    return await fetch(
        `api/MemberServices/GetPcpChangeRequestHistory?${getSearchParamsString({
            memberId,
            skip: (page ?? 0) * pageSize,
            take: pageSize,
        })}`,
        {
            method: 'GET',
            headers,
            signal: abortSignal,
        }
    ).then(handleResponseConversionToJSON);
};

const logShippingAddressMismatch = async (
    authToken: string,
    request: AgentAssistedMemberIdRequest
) => {
    const headers = getAuthHeaders(authToken);
    return await fetch('api/MemberServices/LogShippingAddressMismatch', {
        method: 'POST',
        headers,
        body: JSON.stringify(request),
    });
};

const getSharedMemberCard = async (requestToken: string) => {
    return await fetch(`api/Member/GetSharedMemberCard?token=${requestToken}`, {
        method: 'GET',
    }).then(handleResponseConversionToJSON);
};

const submitMemberIdCardRequest = async (
    authToken: string,
    request: AgentAssistedMemberIdRequest
) => {
    const headers = getAuthHeaders(authToken);
    return await fetch('api/MemberServices/SubmitMemberIdCardRequest', {
        method: 'POST',
        headers,
        body: JSON.stringify(request),
    }).then(handleResponseConversionToJSON);
};

export {
    changePcp,
    getPcpChangeRequests,
    logShippingAddressMismatch,
    getSharedMemberCard,
    submitMemberIdCardRequest,
};
